import { render, staticRenderFns } from "./MultiBranchesModal.vue?vue&type=template&id=1a582ce8&"
import script from "./MultiBranchesModal.vue?vue&type=script&lang=js&"
export * from "./MultiBranchesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports